import styled from "styled-components"
import { SVG_URL } from "../../common/constants"

export const IconRow = styled.div`
  display: flex;
  margin-top: ${props => (props.saved ? "12px" : "10px")};
  align-items: center;
  justify-content: ${props => (props.center ? "center" : "flex-start")};
`

export const StripeBadge = styled.img.attrs({
  src: `${SVG_URL}stripe/powered_by_stripe.svg`,
})`
  width: 90px;
`

export const Lock = styled.img.attrs({
  src: `${SVG_URL}stripe/lock.svg`,
})`
  margin-left: 10px;
`



// WEBPACK FOOTER //
// ./assets/payment/components/IconRow.js